module.exports = __webpack_public_path__ + "static/img/saving_grace_port_lg.be7d7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/saving-grace-banner-campaign/saving_grace_port_lg.jpg
// module id = 273
// module chunks = 2